module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasItems) ? _c('div', {
    staticClass: "programs"
  }, [_c('Header', [_vm._v("Вы хотели посетить")]), _c('ListGrid', _vm._l((_vm.items), function(item, index) {
    return _c('Card', {
      key: index,
      attrs: {
        "image": item.image && item.image.small,
        "title": item.title,
        "to": _vm.getActualParse(item),
        "isFavorite": true
      },
      on: {
        "remove": function($event) {
          return _vm.onDelete(index)
        }
      }
    })
  }), 1)], 1) : _c('Warning', [_c('p', [_vm._v("У всех программ и мероприятий есть символ в виде сердечка.\nНажмите на него, чтобы отложить программу или мероприятие в эту вкладку.\nЕсли мероприятие или программа будут удалены из нашего каталога, они автоматически удалятся и в избранном.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74e973c6","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/favorite/Favorite.vue
// module id = df2bfabf8925413424f6
// module chunks = 54